(function() {
'use strict';

angular.module('TR')
    .directive('sortDropdown', sortDropdown);

function sortDropdown(resourceService) {
    const opposite = {
        asc: 'desc',
        desc: 'asc'
    };
    return {
        restrict: 'E',
        replace: true,
        scope: {
            criteria: '=',
            model: '='
        },
        templateUrl: 'partials/home/directivetemplate?type=SortDropdown',

        link(scope) {
            const cancelWatch = scope.$watch('criteria', function(value) {
               if (value && value.length) {
                   initOptions(scope, value);
                   cancelWatch();
               }
            });
        }
    };

    function initOptions(scope, criteria) {
        scope.options = [];
        if (criteria) {
            _.forEach(criteria, c => {
                _.forEach(c.val, v => {
                    const option = {
                        text: c.name(),
                        value: v
                    };
                    if (c.defaultSort) {
                        const order = c.defaultSort === v ? c.defaultOrder : opposite[c.defaultOrder];
                        const orderResource = order === 'asc' ?
                            (c.ascSuffix ? c.ascSuffix() : resourceService.get('SORTDIRECTIONLABELASCENDING')) :
                            (c.descSuffix ? c.descSuffix() : resourceService.get('SORTDIRECTIONLABELDESCENDING'));
                        const orderText = `(${orderResource})`;
                        option.text += ` ${orderText}`;
                    }
                    scope.options.push(option);
                });
            });
        }
    }
}
})();
